import {
  BorrowerOnboardingDetails,
  DocumentationRequiredType,
  KycIntegrationMethod,
  RequiredFile,
} from '@nemuru-eng/js-api-client';

import { BorrowerOnboardingDetailsDto } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/types/BorrowerOnboardingDetailsDto';
import { MinimalRepositoryItem } from '@/components/shared/components/LastActionsSelectOptions/types/MinimalRepositoryItem';

export interface CustomRequiredFile extends RequiredFile {
  type: DocumentationRequiredType;
  documentationRequiredId: string;
  borrowerId?: string;
}

export interface StoredBorrowerOnboardingDetails extends MinimalRepositoryItem, BorrowerOnboardingDetailsDto {
  nieData?: BorrowerOnboardingDetails['nieData'];
}

export enum KycIntegrationMethodOwner {
  BORROWER = 'borrower',
  COWORROWER = 'coworrower',
}

export interface OwnedKycIntegrationMethod extends KycIntegrationMethod {
  owner: KycIntegrationMethodOwner;
}
